import { Model } from "#/shared/models/model";
import { Row } from "./row";
import { Settings } from "./settings";

export class Layout extends Model {
  constructor(attributes) {
    const rows = attributes.rows?.map((row) => new Row(row)) ?? [];
    const settings = new Settings(attributes.settings);

    super({ ...attributes, rows, settings });
  }

  get defaults() {
    return {
      rows: [],
      settings: new Settings(),
    };
  }
}
